"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.matrixDescriptionRenderer = void 0;
const matrixDescriptionRenderer = ({ textEmpty, textRenderer }) => ({ rowIndex, data }) => {
    const count = data[rowIndex].filter(Boolean).length;
    if (!count) {
        return textEmpty;
    }
    return textRenderer(count);
};
exports.matrixDescriptionRenderer = matrixDescriptionRenderer;
//# sourceMappingURL=matrixDescriptionRenderer.js.map